import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { ICON_BUTTON_TEXT_CLASS, iconButton } from '@noths/polaris-client-styles';
import { DRAWER_HEADER_CLASSNAME, DRAWER_HEADER_TITLE_CLASSNAME } from "../constants/classNames";
import * as styles from "../styles/DrawerHeader.styles";
import { CloseButton } from "../../../elements/IconButtons/CloseButton";
import { IconArrowBack } from "../../../foundations/Iconography/IconArrowBack";
var ICON_SIZE = 24;
export var DrawerHeader = function DrawerHeader(_ref) {
  var disabled = _ref.disabled,
    _ref$headingLevel = _ref.headingLevel,
    Heading = _ref$headingLevel === void 0 ? 'h3' : _ref$headingLevel,
    index = _ref.index,
    onBack = _ref.onBack,
    onClose = _ref.onClose,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(_StyledHeader, {
    className: DRAWER_HEADER_CLASSNAME,
    $_css: styles.header
  }, onBack && /*#__PURE__*/React.createElement(_StyledButton, {
    "data-testid": "back-button-".concat(index),
    disabled: disabled,
    onClick: onBack,
    $_css2: [iconButton, styles.backBtn]
  }, /*#__PURE__*/React.createElement(IconArrowBack, {
    height: ICON_SIZE,
    width: ICON_SIZE
  }), /*#__PURE__*/React.createElement("span", {
    className: ICON_BUTTON_TEXT_CLASS
  }, "Back")), /*#__PURE__*/React.createElement(Heading, {
    className: DRAWER_HEADER_TITLE_CLASSNAME
  }, title), onClose && /*#__PURE__*/React.createElement(_StyledCloseButton, {
    "aria-label": "Close",
    disabled: disabled,
    onClick: onClose,
    size: "large",
    $_css3: [iconButton, styles.closeBtn]
  }));
};
var _StyledHeader = _styled("header")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledButton = _styled2("button")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledCloseButton = /*#__PURE__*/_styled3(CloseButton).withConfig({
  displayName: "DrawerHeader___StyledCloseButton",
  componentId: "sc-740gwg-0"
})(["", ""], function (p) {
  return p.$_css3;
});